$(document).ready(function () {

  var $zoomLens  = null;
  var $zoomPanel = null;

  function createZoomElements() {
    $('.yv-zoom-lens, .yv-zoom-panel').remove();

    $zoomLens = $('<div class="yv-zoom-lens"></div>').css({
      position        : 'absolute',
      width           : '220px',
      height          : '220px',
      border          : '2px solid rgba(80,80,80,0.35)',
      backgroundColor : 'rgba(255,255,255,0.2)',
      pointerEvents   : 'none',
      display         : 'none',
      zIndex          : 10,
      boxSizing       : 'border-box',
      cursor          : 'crosshair'
    });

    $zoomPanel = $('<div class="yv-zoom-panel"></div>').css({
      position        : 'fixed',
      width           : '500px',
      height          : '650px',
      top             : '50%',
      transform       : 'translateY(-50%)',
      border          : '1px solid #ddd',
      backgroundColor : '#fff',
      boxShadow       : '0 6px 24px rgba(0,0,0,0.12)',
      backgroundRepeat: 'no-repeat',
      overflow        : 'hidden',
      display         : 'none',
      zIndex          : 9999,
      pointerEvents   : 'none'
    });

    $('body').append($zoomPanel);
  }

  function initZoomOnSlide($slider) {
    var $activeImg = $slider.find('.is-selected .image-wrapper img');
    if (!$activeImg.length) {
      $activeImg = $slider.find('.yv-product-slider-item:first-child .image-wrapper img');
    }
    if (!$activeImg.length) return;

    var $wrapper = $activeImg.closest('.image-wrapper');

    $wrapper.off('.zoom');
    createZoomElements();
    $wrapper.css('position', 'relative').append($zoomLens);

    $wrapper.on('mouseenter.zoom', function () {
      var src = $activeImg.attr('src');
      if (!src) return;
      $zoomPanel.css('background-image', 'url(' + src + ')').show();
      $zoomLens.show();
    });

    $wrapper.on('mousemove.zoom', function (e) {
      var rect   = $wrapper[0].getBoundingClientRect();
      var dispW  = rect.width;
      var dispH  = rect.height;

      var lensW  = 220;
      var lensH  = 220;
      var panelW = 500;
      var panelH = 650;

      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;

      var lensX = Math.max(0, Math.min(x - lensW / 2, dispW - lensW));
      var lensY = Math.max(0, Math.min(y - lensH / 2, dispH - lensH));

      $zoomLens.css({ left: lensX + 'px', top: lensY + 'px' });

      // Single ratio keeps image proportions intact — no stretching
      var ratio = Math.max(panelW / lensW, panelH / lensH);

      var bgW = dispW * ratio;
      var bgH = dispH * ratio;
      var bgX = -(lensX * ratio);
      var bgY = -(lensY * ratio);

      $zoomPanel.css({
        'background-size'    : bgW + 'px ' + bgH + 'px',
        'background-position': bgX + 'px ' + bgY + 'px'
      });

      var sliderRect = $slider[0].getBoundingClientRect();
      var panelLeft  = sliderRect.right + 15;

      if (panelLeft + panelW > window.innerWidth - 10) {
        panelLeft = sliderRect.left - panelW - 15;
      }

      $zoomPanel.css({ left: panelLeft + 'px' });
    });

    $wrapper.on('mouseleave.zoom', function () {
      $zoomLens.hide();
      $zoomPanel.hide();
    });
  }

  function setupProductSliders() {
    $('.yv-product-big-slider').each(function () {
      var $slider = $(this);

      setTimeout(function () {
        initZoomOnSlide($slider);
      }, 500);

      $slider.on('change.flickity', function () {
        setTimeout(function () {
          initZoomOnSlide($slider);
        }, 150);
      });
    });
  }

  if (document.readyState === 'complete') {
    setupProductSliders();
  } else {
    $(window).on('load', setupProductSliders);
  }

});